import React, { useContext, useRef } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { VehicleContext } from '../Context/VehicleContext';
import {useNavigate} from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';

const HomeAbout = () => {

    const { submitContactForm } = useContext(VehicleContext);
    const recaptchaRef = React.useRef();

    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        fullName: Yup.string()
            .required('Full Name is required'),
        email: Yup.string()
            .email('Invalid email address')
            .required('Email is required'),
        phone: Yup.string()
            .required('Phone number is required'),
        comments: Yup.string()
            .max(500, 'Comments cannot exceed 500 characters')
    });

    const handleSubmit = (values) => {
        console.log(values);
        // Handle form submission (e.g., send data to an API)
    };

    return (
        <>
            <section className='aq-wrap d-lg-flex align-items-center'>
                <div className='ap-left w-50 wow reveal fadeInLeft'>
                    <div className='mxw-580 ms-auto ps-3'>
                        <h2 className='lg-title text-uppercase mb-3'>About Us</h2>
                        <p>We have a large inventory of very clean, low mileage, pre-owned Mercedes including sedans, coupes, convertibles, diesels, wagons and SUV’s.  Our owners and management have over 35 years experience in the industry and they understand your requirements for purchasing this unique automobile.  Because we specialize in Mercedes automobiles, we know what to look for when we buy cars, just as you know what you are looking for.  Service, financing, and fine detailing are available in our indoor showroom located in Pompano Beach, Florida. We can ship your purchase anywhere in the world, and of course trade ins are always welcome.</p>
                    </div>
                </div>
                <div className='ap-right w-50 wow reveal fadeInRight'>
                    <div className='mxw-345 mx-auto'>
                        <div className='lg-title mb-4'>HAVE QUESTIONS? <br />DROP US A LINE</div>
                        <Formik
                            initialValues={{ fullName: '', email: '', phone: '', comments: '' }}
                            validationSchema={validationSchema}
                            onSubmit={async (values, { resetForm }) => {
                                const token = await recaptchaRef.current.executeAsync();
                                recaptchaRef.current.reset(); // Reset after use

                                values.token = token;

                                console.log(values);
                                const data = await submitContactForm(values);

                                if (data.success) {
                                    resetForm();
                                    navigate("/thank-you");
                                } else
                                    alert("There was a problem with your submission");
                            }}
                        >
                            {({ handleSubmit }) => (
                                <Form className='custom-form' onSubmit={handleSubmit}>
                                    <ReCAPTCHA
                                        ref={recaptchaRef}
                                        sitekey="6LfuE4MrAAAAAJdFHXLQK_ktBMzfl8C9I5fpmiJU" // Replace with your actual site key
                                        size="invisible"
                                    />
                                    <div className='form-group'>
                                        <label className='cs-label' htmlFor='fullName'>Full Name</label>
                                        <Field type='text' name='fullName' className='form-control' />
                                        <ErrorMessage name='fullName' component='div' className='text-danger' />
                                    </div>
                                    <div className='form-group'>
                                        <label className='cs-label' htmlFor='email'>Email</label>
                                        <Field type='text' name='email' className='form-control' />
                                        <ErrorMessage name='email' component='div' className='text-danger' />
                                    </div>
                                    <div className='form-group'>
                                        <label className='cs-label' htmlFor='phone'>Phone</label>
                                        <Field type='text' name='phone' className='form-control' />
                                        <ErrorMessage name='phone' component='div' className='text-danger' />
                                    </div>
                                    <div className='form-group'>
                                        <label className='cs-label' htmlFor='comments'>Comments</label>
                                        <Field as='textarea' name='comments' className='form-control h-150' />
                                        <ErrorMessage name='comments' component='div' className='text-danger' />
                                    </div>
                                    <button type='submit' className='transparent-btn w-100 text-uppercase'>Send</button>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </section>
        </>
    )
}

export default HomeAbout